import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router';

import { EventSummary } from './event-summary';
import { ErrorPage } from '../../../../components/error-page';
import { State, useGetWebcastStateQuery } from '../../../../generated/graphql-manager';
import { useAbsoluteRoutes } from '../../../../routes';
import { useUserPermissions } from '../../../hooks/user-permissions';

import accessDeniedOperatorImage from '../../../../assets/access-denied-operator.svg';

export function EventSummaryGuard() {
  const { isAccessToEventSetupAllowed } = useUserPermissions();
  const { t } = useTranslation();
  const { webcastId = '' } = useParams();
  const routes = useAbsoluteRoutes();

  const { data, loading } = useGetWebcastStateQuery({
    variables: { webcastId },
    skip: !webcastId,
  });

  if (!isAccessToEventSetupAllowed) {
    return (
      <ErrorPage
        data-testid="access-denied"
        title={t('common.accessDenied.title')}
        subTitle={t('common.accessDenied.subTitle')}
        image={accessDeniedOperatorImage}
        style={{ gridArea: 'section', height: 'unset', background: 'none' }}
      />
    );
  }

  if (loading) return null;

  if (!data || !data.webcast.state || ![State.POSTLIVE, State.ARCHIVED].includes(data.webcast.state)) {
    return <Navigate to={routes.root} replace />;
  }

  return <EventSummary />;
}
